import { useEffect, useRef } from 'react';
import { handleLocaleUrl, GLOBAL_CLIENT_ONLY_LOCALE } from 'dibs-intl/exports/urls';
import { type TradePhotoNode } from '../InteriorPhotoWrapper.tsx';

type Args = {
    updateHistory: (arg0: string, arg1?: boolean) => void;
    isModal?: boolean;
    photoUrl: string;
    handlePageChange: (arg0: string) => void;
    findPhotoNodeByUrl: (arg0: string) => TradePhotoNode | undefined;
};

export function usePhotoLookupHistory(args: Args): void {
    const { updateHistory, isModal, photoUrl, handlePageChange, findPhotoNodeByUrl } = args;

    const isFirstRunRef = useRef(true);

    useEffect(() => {
        if (isFirstRunRef.current) {
            if (photoUrl) {
                updateHistory(photoUrl, !isModal);
            }
            isFirstRunRef.current = false;
        }
    }, [isModal, updateHistory, photoUrl]);

    useEffect(() => {
        const handlePopState = (): void => {
            const storedPhotoUrl = window.history.state as string;
            const photoNode = findPhotoNodeByUrl(storedPhotoUrl);

            if (storedPhotoUrl && photoNode) {
                handlePageChange(storedPhotoUrl);
            } else {
                window.location.assign(
                    handleLocaleUrl(window.location.href, GLOBAL_CLIENT_ONLY_LOCALE)
                );
            }
        };

        window.onpopstate = handlePopState;

        return () => {
            window.onpopstate = null;
        };
    }, [findPhotoNodeByUrl, handlePageChange]);
}
